import React from "react";
import ReduxThunk from "redux-thunk";
import axios from "axios";
import { render } from "react-dom";
import { createStore, applyMiddleware } from "redux";
import { Provider } from "react-redux";
import { HashRouter } from "react-router-dom";

import { SharedContent } from "./Layout/SharedContent";
import { shareReducer } from "../../Reducers/ShareReducer";
import { loadFeatureFlagsWithOverrides } from "../../Common/CurrentFeatureFlags";

loadFeatureFlagsWithOverrides();

export const store = createStore(shareReducer, applyMiddleware(ReduxThunk));

axios.interceptors.request.use((config) => {
    //this tricks asp.net mvc into thinking this is an ajax request so we can catch errors similar to legacy scout
    config.headers.common["X-Requested-With"] = "XMLHttpRequest";
    return config;
});

render(
    <Provider store={store}>
        <HashRouter>
            <SharedContent />
        </HashRouter>
    </Provider>,
    document.getElementById("root")
);
